import { useState, useEffect } from 'react';

export function ResumePage() {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const checkSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    setIsSafari(checkSafari);
  }, []);

  return (
    <div className="resume-wrapper">
      <div className="resume-container">
        {!isSafari ? (
          <embed
            src="E Gopkalo Resume.pdf"
            width="100%"
            height="100%"
            type="application/pdf"
          />
        ) : (
          <img
            src="/E Gopkalo Resume.png"
            alt="E Gopkalo Resume"
            style={{ width: '100%', height: 'auto' }}
          />
        )}
      </div>
    </div>
  );
}
